/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import type { ComponentChild } from 'preact';

// Core
import useHeader from '@client/pages/useHeader';

// Resources
import IllustrationImg from '@/client/assets/img/illustration/login.jpg';

/*----------------------------------
- TYPES
----------------------------------*/

export type Props = { 
    header?: ComponentChild | ComponentChild[],
    children?: ComponentChild | ComponentChild[],
    title: string,
    description: string,
    className?: string,
}

/*----------------------------------
- COMPONENT 
----------------------------------*/
export default ({ children, title, description, className }: Props) => {

    useHeader({ title, description });

    return (
        <div class="col sp-0" style={{
            minHeight: '100vh',
            padding: '0.8vw',
            background: 'black'
        }}>
            <div class={"card bg img row-1 wrap" + (className ? ` ${className}` : '')} style={{
                background: 'url(' + IllustrationImg + ') center',
                backgroundSize: 'cover',
                padding: '10vh 0 15vh 0'
            }}>
                {children}
            </div>
        </div>
    )
}